export const defaultRecaptchaMessage = 'This site is protected by reCAPTCHA and the Google <a target="_blank" href="https://policies.google.com/privacy" rel="noopener">Privacy Policy</a> and <a target="_blank" href="https://policies.google.com/terms" rel="noopener">Terms of Service</a> apply.'

export async function getRecaptchaMessage() {
    try {
        const response = await fetch('/api/common/stringresources', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                widget: 'WidgetComponent.Forms.Labels',
            }),
        });

        if (!response.ok) {
            throw new Error('Unable to fetch recaptcha message string resource.')
        }

        const json = await response.json();
        const resource = json.find(resource => resource.name === 'WidgetComponent.Forms.Labels.RecaptchaMessage')

        if (!resource) {
            throw new Error('Recaptcha message string resource not found in response.')
        }

        return resource.value
    } catch (error) {
        console.error(error)

        return defaultRecaptchaMessage
    }
}